import React from 'react';
import createSVG from '../createSVG';

const BibliothekenImport = ({style}) => (
  <path style={style} fill="none" fillRule="evenodd" stroke="#6ED2A0" strokeWidth="3" d="M48.751 66.2H9V2h92.569v64.2h-39.75m-6.534-26.75V109m0-69.55l15.666 12.84M55.285 39.45L39.618 52.29" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(BibliothekenImport);
